import { useUser } from '@/queries/useUser';
import { LuPlus } from 'react-icons/lu';
import { ChangePlanModal } from '@/features/subscriptions/components/ChangePlanModal';
import { EmptyStateLayout } from '../EmptyStateLayout';
import { useEmptyStateActions } from '../../hooks/useEmptyStateActions';
import { BUTTON_LABELS, BUTTON_NAMES, EMPTY_STATE_CONTENT } from '../../constants';

import EmptyEmailFlow from '@/assets/images/flow-empty.svg';

interface IntroductionStepProps {
    onComplete: () => void;
}

export const IntroductionStep = ({ onComplete }: IntroductionStepProps) => {
    const { user } = useUser();
    const isEmailFlowsAllowed = user?.subscription_tier_allowed_modules?.includes('email-flows');

    const { handleButtonClick, isModalOpen, setIsModalOpen } = useEmptyStateActions({
        variant: isEmailFlowsAllowed ? 'action' : 'upgrade',
        actionRoute: '', // Not used when variant is 'action' with custom handler
    });

    const buttonAction = isEmailFlowsAllowed ? onComplete : handleButtonClick;

    const buttonName = isEmailFlowsAllowed ? BUTTON_NAMES.ONBOARDING_GET_STARTED : BUTTON_NAMES.ONBOARDING_UPGRADE;
    const buttonLabel = isEmailFlowsAllowed ? BUTTON_LABELS.GET_STARTED : BUTTON_LABELS.UPGRADE_TO_PRO;
    const buttonIcon = isEmailFlowsAllowed ? undefined : <LuPlus />;

    const content = EMPTY_STATE_CONTENT.FLOWS_ONBOARDING;

    return (
        <>
            <EmptyStateLayout
                title={content.title}
                description={content.description}
                bulletPointsHeading={content.bulletPointsHeading}
                bulletPoints={content.bulletPoints}
                buttonText={buttonLabel}
                buttonIcon={buttonIcon}
                buttonName={buttonName}
                onButtonClick={buttonAction}
                illustration={EmptyEmailFlow}
                imageAlt='Email Flow illustration'
            />

            {/* Change Plan Modal */}
            <ChangePlanModal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} />
        </>
    );
};
